import styles from "./TechCard.module.scss";
import { ReactComponent as Line } from "../../assets/technologies/line.svg";
import Accordion from "./Accordion";
import { useColorModeValue } from "../../hooks/useColorModeValue";
function TechCard(props) {
  return (
    <div>
      <div className={styles["main"]}>
        <Line fill={props.fill} width="14vw" />
        <div className={styles[useColorModeValue("tech-containerLight", "tech-containerDark")]}>
          <img src={props.image} alt="logo" />
          <h2>{props.title}</h2>
          <div className={styles["accordion"]}>
            {props.data.map(({ content }) => (
              <Accordion content={content} fill={props.fill} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default TechCard;
